import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Select2OptionData } from 'ng-select2';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CreateResult } from '../../models/create-result';
import { MerchantTerminalConfigViewModel } from '../../models/merchant-terminal-config-view-model';
import { ParticipantMappingViewModel } from '../../models/participant-mapping-view-model';
import { ParticipantViewModel } from '../../models/participant-view-model';
import { TerminalConfigViewModel } from '../../models/terminal-config-view-model';
import { AuthenticationService } from '../../services/authentication.service';
import { CardAcceptorConfigService } from '../../services/card-acceptor-config.service';
import { CommsProfileService } from '../../services/comms-profile.service';
import { PermissionEnum } from '../../services/guards/permissions';
import { MerchantService } from '../../services/merchant.service';
import { ParticipantService } from '../../services/participant.service';
import { ProductProfileService } from '../../services/product-profile.service';
import { TerminalCapabilityService } from '../../services/terminal-capability.service';
import { TerminalConfigService } from '../../services/terminal-config.service';
import { TerminalService } from '../../services/terminal.service';
import { UserDataStoreService } from '../../services/user-data-store.service';

@Component({
  selector: 'app-merchant-terminals-configuration',
  templateUrl: './merchant-terminals-configuration.component.html',
  styleUrls: ['./merchant-terminals-configuration.component.scss']
})
export class MerchantTerminalsConfigurationComponent implements OnInit {

  public merchantTypes: Select2OptionData[];
  public banks: Select2OptionData[];
  public accountTypes: Select2OptionData[];
  public cardAcceptorConfigs: Select2OptionData[];
  public services: Select2OptionData[];
  public displayCountryCode = false;
  public displayMPOSContent: false;
  public manualPanEntry: false;
  public select2options: any = {
    multiple: false,
    width: '100%',
    allowClear: true
  };

  public cardSets: Select2OptionData[];
  public countries: Select2OptionData[];
  public regions: Select2OptionData[];

  public termTypes: Select2OptionData[] = [];
  public productProfiles: Select2OptionData[] = [];
  public capabilityProfiles: Select2OptionData[] = [];
  public commsProfiles: Select2OptionData[] = [];
  public parameterDownloadInteractionDays: Select2OptionData[] = [
    { id: "1", text: 'Sunday' },
    { id: "2", text: 'Monday' },
    { id: "4", text: 'Tuesday' },
    { id: "8", text: 'Wednesday' },
    { id: "15", text: 'Thursday' }
  ];
  public terminalInteractionBankingWindowTimes: Select2OptionData[] = [
    { id: "", text: "" },
    { id: "00:00 - 00:30", text: "00:00 - 00:30" },
    { id: "00:30 - 01:00", text: "00:30 - 01:00" },
    { id: "01:00 - 01:30", text: "01:00 - 01:30" },
    { id: "01:30 - 02:00", text: "01:30 - 02:00" },
    { id: "02:00 - 02:30", text: "02:00 - 02:30" },
    { id: "02:30 - 03:00", text: "02:30 - 03:00" },
    { id: "03:00 - 03:30", text: "03:00 - 03:30" },
    { id: "03:30 - 04:00", text: "03:30 - 04:00" },
    { id: "04:00 - 04:30", text: "04:00 - 04:30" },
    { id: "04:30 - 05:00", text: "04:30 - 05:00" },
    { id: "05:00 - 05:30", text: "05:00 - 05:30" },
    { id: "05:30 - 06:00", text: "05:30 - 06:00" },
    { id: "06:00 - 06:30", text: "06:00 - 06:30" },
    { id: "06:30 - 07:00", text: "06:30 - 07:00" },
    { id: "07:00 - 07:30", text: "07:00 - 07:30" },
    { id: "07:30 - 08:00", text: "07:30 - 08:00" },
    { id: "08:00 - 08:30", text: "08:00 - 08:30" },
    { id: "08:30 - 09:00", text: "08:30 - 09:00" },
    { id: "09:00 - 09:30", text: "09:00 - 09:30" },
    { id: "09:30 - 10:00", text: "09:30 - 10:00" },
    { id: "10:00 - 10:30", text: "10:00 - 10:30" },
    { id: "10:30 - 11:00", text: "10:30 - 11:00" },
    { id: "11:00 - 11:30", text: "11:00 - 11:30" },
    { id: "11:30 - 12:00", text: "11:30 - 12:00" },
    { id: "12:00 - 12:30", text: "12:00 - 12:30" },
    { id: "12:30 - 13:00", text: "12:30 - 13:00" },
    { id: "13:00 - 13:30", text: "13:00 - 13:30" },
    { id: "13:30 - 14:00", text: "13:30 - 14:00" },
    { id: "14:00 - 14:30", text: "14:00 - 14:30" },
    { id: "14:30 - 15:00", text: "14:30 - 15:00" },
    { id: "15:00 - 15:30", text: "15:00 - 15:30" },
    { id: "15:30 - 16:00", text: "15:30 - 16:00" },
    { id: "16:00 - 16:30", text: "16:00 - 16:30" },
    { id: "16:30 - 17:00", text: "16:30 - 17:00" },
    { id: "17:00 - 17:30", text: "17:00 - 17:30" },
    { id: "17:30 - 18:00", text: "17:30 - 18:00" },
    { id: "18:00 - 18:30", text: "18:00 - 18:30" },
    { id: "18:30 - 19:00", text: "18:30 - 19:00" },
    { id: "19:00 - 19:30", text: "19:00 - 19:30" },
    { id: "19:30 - 20:00", text: "19:30 - 20:00" },
    { id: "20:00 - 20:30", text: "20:00 - 20:30" },
    { id: "20:30 - 21:00", text: "20:30 - 21:00" },
    { id: "21:00 - 21:30", text: "21:00 - 21:30" },
    { id: "21:30 - 22:00", text: "21:30 - 22:00" },
    { id: "22:00 - 22:30", text: "22:00 - 22:30" },
    { id: "22:30 - 23:00", text: "22:30 - 23:00" },
    { id: "23:00 - 23:30", text: "23:00 - 23:30" }
  ];
  public terminalInteractionParameterTimes: Select2OptionData[] = [
    { id: "23:00 - 23:30", text: "23:00 - 23:30" },
    { id: "23:30 - 00:00", text: "23:30 - 00:00" },
    { id: "00:00 - 00:30", text: "00:00 - 00:30" },
    { id: "00:30 - 01:00", text: "00:30 - 01:00" },
    { id: "01:00 - 01:30", text: "01:00 - 01:30" },
    { id: "01:30 - 02:00", text: "01:30 - 02:00" },
    { id: "02:00 - 02:30", text: "02:00 - 02:30" },
    { id: "02:30 - 03:00", text: "02:30 - 03:00" },
    { id: "03:00 - 03:30", text: "03:00 - 03:30" },
    { id: "03:30 - 04:00", text: "03:30 - 04:00" },
    { id: "04:00 - 04:30", text: "04:00 - 04:30" },
    { id: "04:30 - 05:00", text: "04:30 - 05:00" },
    { id: "05:00 - 05:30", text: "05:00 - 05:30" },
    { id: "05:30 - 06:00", text: "05:30 - 06:00" },
    { id: "06:00 - 06:30", text: "06:00 - 06:30" },
    { id: "06:30 - 07:00", text: "06:30 - 07:00" },
    { id: "07:00 - 07:30", text: "07:00 - 07:30" }
  ];
  public canManage: boolean;
  public TerminalConfigFormGroup: FormGroup;
  public terminalConfigsSelect2: Select2OptionData[] = [];
  public participantIdSelect2: Select2OptionData[] = [];
  private terminalConfigs: TerminalConfigViewModel[] = [];
  private participants: ParticipantViewModel[] = [];
  private merchantTerminalConfig: MerchantTerminalConfigViewModel;
  private merchantTerminalConfigs: MerchantTerminalConfigViewModel[] = [];
  public participantSelected: boolean;
  public raiseDanger: boolean;
  public danger: string;
  public result: CreateResult;

  constructor(private _terminalConfigService: TerminalConfigService,
    private _commsProfileService: CommsProfileService,
    private _productProfileService: ProductProfileService,
    private _terminalCapabilityService: TerminalCapabilityService,
    private _router: Router,
    private _userDataStore: UserDataStoreService,
    private _authenticationService: AuthenticationService,
    private _modalService: NgbModal,
    private _terminalService: TerminalService,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _toastService: ToastrService,
    private _formBuilder: FormBuilder,
    private _cardAcceptorConfigService: CardAcceptorConfigService,
    private _merchantService: MerchantService,
    private _http: HttpClient,
    private _participantService: ParticipantService) {

    this.canManage = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditMerchantTerminalConfig]);
    if (!this.canManage) {
      this._toastService.warning("You do not have the required permissions to view this page, Please contact your system administrator", "Warning");
      this._router.navigate(['/']);
    }

    this.participantSelected = false;
  }

  async ngOnInit(): Promise<void> {

    this.TerminalConfigFormGroup = this._formBuilder.group({
      participantId: ['', Validators.compose([Validators.required])],
      terminalConfig: ['', Validators.compose([Validators.required])],
      terminalType: ['', Validators.compose([Validators.required])],
      productProfile: ['', Validators.compose([Validators.required])],
      terminalCapabilities: ['', Validators.compose([Validators.required])],
      commsProfile: ['', Validators.compose([Validators.required])],
      countryFC: ['', Validators.compose([Validators.required])],
      cardSetFC: ['', Validators.compose([Validators.required])]
    });


    var participantId = this._userDataStore.selectedParticipant.id;

    this.countries = (await this._merchantService.GetCountries()).map((x) => {
      return { id: x.countryCode, text: x.country }
    });

    this.regions = (await this._merchantService.GetRegions()).map((x) => {
      return { id: x.regionCode, text: x.regionName }
    });

    this.merchantTypes = (await this._merchantService.GetMerchantTypes()).map((x) => {
      return { id: x.code, text: `${x.code} - (${x.displayName})` }
    });

    this.cardSets = (await this._merchantService.GetCardSets()).map((x) => {
      return { id: x.cardSet, text: x.cardSet }
    });

    this.termTypes = (await this._terminalService.GetTermTypes()).map((x) => {
      return { id: x.id.toString(), text: x.name }
    });

    this.productProfiles = (await this._productProfileService.GetProductProfiles()).map((x) => {
      return { id: x.profileId.toString(), text: x.productProfile }
    });

    this.capabilityProfiles = (await this._terminalCapabilityService.GetTerminalCapabilities()).map((x) => {
      return { id: x.capabilityProfileId.toString(), text: x.capabilityProfileName }
    });

    this.commsProfiles = (await this._commsProfileService.GetCommsProfiles()).map((x) => {
      return { id: x.commsProfileId.toString(), text: x.description }
    });


    this.merchantTerminalConfigs = await this._terminalConfigService.GetAllMerchantTerminalsConfigs();
        
    this.participants = await this._participantService.GetAllParticipants();

    const partIds = (this.merchantTerminalConfigs.filter(m => m.participantId > 0)).map(x => x.participantId);

    this.participants = this.participants.filter(x => !partIds.includes(x.id))
       
    this.participantIdSelect2 = (this.participants).map((x) => {
      return { id: x.id.toString(), text: x.name + ' (' + x.id + ')' }
    });

  }

  async participantChange(participantId: number) {
    if (participantId != undefined && participantId > 0) {

      this.participantSelected = true;

      this.terminalConfigs = await this._terminalConfigService.GetAllConfigsByParticipantId(participantId);

      this.terminalConfigsSelect2 = (this.terminalConfigs).map((x) => {
        return { id: x.id.toString(), text: x.name }
      });
    }
  }

  async addConfig(): Promise<void> {
    if (this.TerminalConfigFormGroup.invalid) {
      this.danger = "Form is invalid, all fields are mandatory."
      this.raiseDanger = true;
    }
    else {
      this.danger = "";
      this.raiseDanger = false;

      let merchantTerminalGroup: MerchantTerminalConfigViewModel = {
        id: 0,
        participantId: this.TerminalConfigFormGroup.controls["participantId"].value,
        cardSet: this.TerminalConfigFormGroup.controls["cardSetFC"].value,
        commsProfile: this.TerminalConfigFormGroup.controls["commsProfile"].value,
        country: this.TerminalConfigFormGroup.controls["countryFC"].value,
        productProfile: this.TerminalConfigFormGroup.controls["productProfile"].value,
        terminalCapabilities: this.TerminalConfigFormGroup.controls["terminalCapabilities"].value,
        terminalConfig: this.TerminalConfigFormGroup.controls["terminalConfig"].value,
        terminalType: this.TerminalConfigFormGroup.controls["terminalType"].value,
      };


      this.result = await this._terminalConfigService.AddMerchantTerminalConfig(merchantTerminalGroup);

      if (this.result.success) {
        this._toastService.success("Config added successfully.", 'success');
        //refresh grid
        this.merchantTerminalConfigs = await this._terminalConfigService.GetAllMerchantTerminalsConfigs();
      }
      else {

        this._toastService.error(this.result.message, 'error');
      }
    }
  }
}
